import {
  CreateRigRequest,
  RigGetDto,
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  UpdateRigRequest,
  EmptyResponse,
  Error,
  ImportRigsCsvResult,
  OptionItemDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class RigsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateRigRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<RigGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
      /**  */
      partnerSiteId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<RigGetDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted'],
        partnerSiteId: params['partnerSiteId']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<RigGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateRigRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<RigGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  /**
   * Import rigs from a CSV file for a Partner Site.
   */
  static importCsv(
    params: {
      /** Partner Site ID */
      partnerSiteId: number;
      /** CSV file */
      file: File;
    },
    options: IRequestOptions = {}
  ): Promise<Response<ImportRigsCsvResult>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs/import/{partnerSiteId}';
      url = url.replace('{partnerSiteId}', params['partnerSiteId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      const formData = new FormData();
      formData.append('file', params.file);
      configs.data = formData;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getOptions(
    params: {
      /**  */
      partnerSiteId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<OptionItemDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/rigs/options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { partnerSiteId: params['partnerSiteId'] };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
